import React, { useState, useEffect } from 'react'
import * as components from '../../components'
import { useDispatch } from 'react-redux'
import * as rest from '../../services'
import { showErrorToast } from '../../state/toasts'
import * as ReactBootstrap from 'react-bootstrap'
import {RepairPayload, Ticket} from "../../types";
import {AxiosResponse} from "axios";
import {Loading} from "../../components";
import PONumberForm from "./PONumberForm";
export type RepairCreateButtonProps={
  ticket:Ticket
}


export const RepairCreateButton = ({ ticket }:RepairCreateButtonProps) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState<boolean>(false)
  const [initialPayload, setInitialPayload] = useState<RepairPayload>()
  const [response, setResponse] = useState<AxiosResponse | null>(null)
  const [askPONUmber,setAskPONUMber]= useState<boolean>(false)
  const getInitialPayload = () => {
    setLoading(true)
    new rest.TicketService(ticket.url)
        .get_gsx_data().then((res) => {
          setInitialPayload(res)
          if (res?.referenceNumber==="DROPOFF"){
              setAskPONUMber(true)
          }
        })
        .catch((errors) => {
          dispatch(
              showErrorToast(
                  'Error',
                  "Could not Load GSX Initial Payload"
              )
          )
        }).finally(()=>{
          setLoading(false)
    })
  }

  const handleCreate = () => {
    setLoading(true)
    new rest.GSXService()
      .repair_create({
        data: initialPayload,
      })
      .then((res: React.SetStateAction<AxiosResponse<any, any> | null>) => {
        setResponse(res)
      })
      .catch((errors: { response: { data: React.SetStateAction<AxiosResponse<any, any> | null> } }) => {
        setResponse(errors.response.data)
      }).finally(()=>{
        setLoading(false)
    })

  }
  const handleDraft = () => {
    setLoading(true)
    new rest.GSXService()
      .repair_draft({
        data: initialPayload,
      })
      .then((res: React.SetStateAction<AxiosResponse<any, any> | null>) => {
         setResponse(res)
      })
      .catch((errors: { response: { data: React.SetStateAction<AxiosResponse<any, any> | null> } }) => {
        setResponse(errors.response.data)
      }).finally(()=>{
        setLoading(false)
    })
  }
  useEffect(() => {
    getInitialPayload()
  }, [])

  const handlePONumberUpdate=(data)=>{
        setInitialPayload({...initialPayload,...data})
        setAskPONUMber(false)
  }

  return (
    <>

        {askPONUmber?<><PONumberForm onSubmit={handlePONumberUpdate}/></>: <><div className="mb-3 ps-3 text-end">
          <components.Confirm
            onConfirm={() => {
              handleCreate()
            }}
            body="Are you sure you want to create a GSX Repair with following details?"
            confirmText="Confirm Repair Data"
            confirmBSStyle="danger"
            title="Confirm Repair Data"
          >
            <ReactBootstrap.Button variant="dark" >
              {components.ICONS.PLUS} Create New Repair
            </ReactBootstrap.Button>
          </components.Confirm>
          <components.Confirm
            onConfirm={() => {
              handleDraft()
            }}
            body="Are you sure you want to create a GSX Repair with following details?"
            confirmText="Confirm Repair Data"
            confirmBSStyle="danger"
            title="Confirm Repair Data"
          >
         <span className="ps-3 text-end">   <ReactBootstrap.Button variant="primary">
              {components.ICONS.EDIT} Save For Later
            </ReactBootstrap.Button>
         </span>
          </components.Confirm>
        </div>
               <>
            {loading && <Loading/>}
            {response && <components.JSONToHTMLTable
              tableClassName="table table-sm table-striped table-bordered"
              data={response}
            />
            }
            {!response && initialPayload  && <components.JSONToHTMLTable
              tableClassName="table table-sm table-striped table-bordered"
              data={initialPayload}
            />
            }
            {initialPayload && initialPayload.messages && initialPayload.messages.length >0 && <ReactBootstrap.Alert variant="danger">
          {initialPayload.messages.join && initialPayload.messages.join()}
        </ReactBootstrap.Alert>}

          </></>
}




    </>
  )
}
